module.exports = __webpack_public_path__ + "static/CoronavirusNews-65942827e0f1f11444ba49273ca8cf2b.jpg";